import { useEffect } from 'react';

import { useAppSelector } from './react-redux';
import { ThemePreference } from '../components/auth/login/store';
import { getCurrentUserDefaults } from '../components/home/store/selectors';

export const useThemePreference = () => {
    const { themePreference } = useAppSelector(getCurrentUserDefaults);

    useEffect(() => {
        const localStorageTheme = (localStorage.getItem('theme') as ThemePreference | undefined);
        if (localStorageTheme !== themePreference) {
            localStorage.setItem('theme', themePreference);
            document.querySelector('html')?.setAttribute('data-theme', themePreference);
        }
    }, [themePreference]);
};
